/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';

import {ClrResponsiveNavCodes} from './clrResponsiveNavCodes';
import {ClrResponsiveNavControlMessage} from './clrResponsiveNavControlMessage';
export class ClrResponsiveNavigationService {
public responsiveNavList: number[] = [];
private registerNavSubject: Subject<number[]> = new Subject<number[]>();
private controlNavSubject: Subject<ClrResponsiveNavControlMessage> = new Subject<ClrResponsiveNavControlMessage>();
/**
 * @return {?}
 */
get registeredNavs(): Observable<number[]> {
        return this.registerNavSubject.asObservable();
    }
/**
 * @return {?}
 */
get navControl(): Observable<ClrResponsiveNavControlMessage> {
        return this.controlNavSubject.asObservable();
    }
constructor() {
        this.closeAllNavs();  // We start with all navs closed
    }
/**
 * @param {?} navLevel
 * @return {?}
 */
registerNav(navLevel: number): void {
        if (!navLevel || this.isNavRegistered(navLevel)) {
            return;
        }
        this.responsiveNavList.push(navLevel);
        this.registerNavSubject.next(this.responsiveNavList);
    }
/**
 * @param {?} navLevel
 * @return {?}
 */
isNavRegistered(navLevel: number): boolean {
        if (this.responsiveNavList.indexOf(navLevel) > -1) {
            console.error("Multiple clr-nav-level " + navLevel +
                          " attributes found. Please make sure that only one exists");
            return true;
        }
        return false;
    }
/**
 * @param {?} navLevel
 * @return {?}
 */
unregisterNav(navLevel: number) {
        const /** @type {?} */ index = this.responsiveNavList.indexOf(navLevel);
        if (index > -1) {
            this.responsiveNavList.splice(index, 1);
            this.registerNavSubject.next(this.responsiveNavList);
        }
    }
/**
 * @param {?} controlCode
 * @param {?} navLevel
 * @return {?}
 */
sendControlMessage(controlCode: string, navLevel: number) {
        const /** @type {?} */ message: ClrResponsiveNavControlMessage = new ClrResponsiveNavControlMessage(controlCode, navLevel);
        this.controlNavSubject.next(message);
    }
/**
 * @return {?}
 */
closeAllNavs() {
        const /** @type {?} */ message: ClrResponsiveNavControlMessage =
            new ClrResponsiveNavControlMessage(ClrResponsiveNavCodes.NAV_CLOSE_ALL, -999);
        this.controlNavSubject.next(message);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrResponsiveNavigationService_tsickle_Closure_declarations() {
/** @type {?} */
ClrResponsiveNavigationService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrResponsiveNavigationService.ctorParameters;
/** @type {?} */
ClrResponsiveNavigationService.prototype.responsiveNavList;
/** @type {?} */
ClrResponsiveNavigationService.prototype.registerNavSubject;
/** @type {?} */
ClrResponsiveNavigationService.prototype.controlNavSubject;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
